export default __webpack_public_path__ + "static/media/sample2.2975f23c.png";